import { render, staticRenderFns } from "./IconSvgSnmmiMessages.vue?vue&type=template&id=cb22920a&scoped=true&"
import script from "./IconSvgSnmmiMessages.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnmmiMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb22920a",
  null
  
)

export default component.exports